<template>
  <a-modal
    v-model="visible"
    :title="title || modalTitle"
    :destroy-on-close="true"
    :footer="null"
    wrap-class-name="fullscreen-modal"
    dialog-class="answer-modal"
    width="1000px"
    :z-index="1010"
    :after-close="afterClose"
  >
    <div class="modal-content">
      <div class="answer-overall">
        <div
          :class="[
            'answer-score',
            textEvaluate.result.scoreRate >= 85
              ? 'col-1DC060'
              : textEvaluate.result.scoreRate >= 60
                ? 'col-FFA516'
                : 'col-FF3C30'
          ]"
        >
          <span class="score">{{ Number(textEvaluate.result.overall).toFixed(2) }}</span>
          <span class="text">分</span>
        </div>
        <div class="answer-star">
          <template v-for="index in 5">
            <img
              :key="index"
              class="answer-star-img"
              :src="
                index <= fetchStarNum(textEvaluate.result.scoreRate)
                  ? require('@/assets/common/star_highlight.png')
                  : require('@/assets/common/star_grey.png')
              "
              alt=""
            />
          </template>
        </div>
      </div>
      <div class="answer-evaluate">
        <div class="answer-result">
          <div
            v-for="blank in textEvaluate.result.blanksResult"
            :key="blank.id"
            :class="['answer-item', blank.answers.includes(blank.answer) ? 'correct' : 'error']"
          >
            <span class="answer-item-seq mr-10">{{ blank.text }}.</span>
            <span class="answer-item-value">{{ blank.answer }}</span>
          </div>
        </div>
        <div class="reference-answer">
          <div class="reference-answer-title">参考答案：</div>
          <div
            v-for="blank in textEvaluate.result.blanksResult"
            :key="blank.id"
            :class="['reference-answer-item', blank.answers.includes(blank.answer) ? 'correct' : 'error']"
          >
            <span class="answer-item-seq mr-10">{{ blank.text }}</span>
            <span class="answer-item-value">{{ blank.answers.join('/') }}</span>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
// 课文听读、教辅、本地专版评测弹框
export default {
  name: 'GapFillingTextEvaluate',
  data() {
    return {
      visible: false,
      title: '',
      textEvaluate: {
        result: {
          overall: 0
        },
        audioUrl: ''
      },
      onClose: null
    }
  },
  computed: {
    modalTitle() {
      return this.$store.getters.activeAnswer && this.$store.getters.activeAnswer.id
        ? (this.$store.getters.activeAnswer.realName || this.$store.getters.activeAnswer.name) + '的作答详情'
        : '作答详情'
    }
  },
  methods: {
    changeVisible(bol) {
      this.visible = bol
    },
    // 获取得分星星数量
    fetchStarNum(overall) {
      overall = Number(overall)
      if (overall >= 80) {
        return 5
      } else if (overall >= 60) {
        return 4
      } else if (overall >= 40) {
        return 3
      } else if (overall >= 20) {
        return 2
      } else {
        return 1
      }
    },
    afterClose() {
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-modal {
  &.answer-modal {
    .ant-modal-content {
      border-radius: 24px;
      .ant-modal-header {
        height: 72px;
        background: url('@/assets/common/model_title.png');
        background-size: 100% 72px;
        border-radius: 24px 24px 0 0;
        padding: 22px 40px;
        .ant-modal-title {
          color: #333333;
          font-size: 20px;
          line-height: 28px;
          font-weight: bold;
        }
      }
      .ant-modal-close {
        top: 14px;
        right: 14px;
        .ant-modal-close-x {
          width: 44px;
          height: 44px;
          line-height: 44px;
        }
      }
      .ant-modal-body {
        border-radius: 0 0 24px 24px;
        padding: 0;
        max-height: calc(100vh - 312px);
        padding-bottom: 28px;
        overflow-y: auto;
        .modal-content {
          .answer-overall {
            width: 330px;
            //height: 202px;
            padding: 20px 0;
            margin: 0 auto;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            .answer-score {
              display: flex;
              align-items: center;
              .score {
                font-size: 34px;
              }
              .text {
                margin-left: 4px;
                font-size: 18px;
              }
            }
            .answer-star {
              margin-bottom: 20px;
              .answer-star-img {
                width: 16px;
                height: 16px;
                & + .answer-star-img {
                  margin-left: 4px;
                }
              }
            }
          }
          .answer-evaluate {
            display: flex;
            flex-flow: column;
            //justify-content: center;
            //align-items: center;
            padding: 0 40px;
            .answer-result {
              margin: 0 auto;
              margin-bottom: 20px;
              .answer-item {
                width: 400px;
                padding: 8px 40px 8px 20px;
                border-radius: 8px;
                font-size: 20px;
                line-height: 28px;
                color: #ffffff;
                display: flex;
                align-items: center;
                & + .answer-item {
                  margin-top: 10px;
                }
                &.error {
                  background: #ff3c30;
                }
                &.correct {
                  background: #1dc060;
                }
                .answer-item-value {
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-align: center;
                }
              }
            }
            .reference-answer {
              font-size: 20px;
              line-height: 28px;
              color: #1976ff;
            }
          }
        }
      }
    }
  }
}
</style>
